import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getNesachTabu = ({data, onDownloadProgress, setSource}) => dispatch => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  setSource(source);

  return axios.post(api.GET_NESACH_TABU, data, {
    onDownloadProgress,
    cancelToken: source.token,
  })
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
      const {fileData, areaData} = body;

      return {
        file: `data:application/pdf;base64,${fileData}`,
        ...areaData
      };
    });
};
